import React from 'react'
import { PhoneInput } from 'react-international-phone'

const PhoneInputWrapper = React.forwardRef((props, ref) => (
  <label className='form-input'>
    <span>
      {props.label}
      {props.mandatory && <b>*</b>}
    </span>
    <div>
      <PhoneInput
        innerRef={ref}
        defaultCountry='us'
        value={props.defaultValue}
        className='phone-input-wrapper'
        inputClassName='form-control'
        error={true}
        inputProps={{
          name: 'phone',
          id: 'phone'
        }}
        onChange={(phone, country) => props.onChange(phone, country)}
      />
    </div>
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default PhoneInputWrapper
